// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202608041610/js/" + chunkId + "." + {"44":"553cd118","225":"1097344f","481":"20ee9922","486":"4350c0c6","770":"2f6a4f04"}[chunkId] + ".0.39066967139990016.chunk.js";
};